<template>
  <v-dialog v-model="dialog" persistent width="600">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9> <v-icon>edit</v-icon> Editar feriado </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex md6>
                <v-text-field
                  label="Descripción"
                  v-model="form.descripcion"
                  :rules="$validate(['required'])"
                  required
                  maxlength="1000"
                ></v-text-field>
              </v-flex>
              <v-flex md6>
                <v-text-field
                  label="Fecha"
                  type="date"
                  v-model="form.fecha"
                  :rules="$validate(['required'])"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex md12>
                <v-autocomplete
                  :items="tipos_feriados"
                  item-value="id"
                  item-text="descripcion"
                  v-model="form.nacional"
                  label="Tipo"
                  maxlength="100"
                  :rules="$validate(['required'])"
                  required
                  @change="onTipoFeriadoChange"
                />
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex md12>
                <v-autocomplete
                  v-if="form.nacional == 2 || form.nacional == 3"
                  :items="departamentos"
                  item-value="id"
                  item-text="valor"
                  v-model="form.id_parametro"
                  label="Departamento"
                  maxlength="100"
                  :rules="form.nacional == 2 || form.nacional == 3 ? $validate(['required']) : []"
                  required
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn color="primary" type="submit" :loading="loading">
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";

export default {
  mixins: [validate],
  data() {
    return {
      tipos_feriados: [
        { id: 1, descripcion: "Nacional" },
        { id: 2, descripcion: "Departamental" },
        { id: 3, descripcion: "Internacional" }
      ],
      departamentos: [],
      dialog: false,
      form: {},
      valid: false,
      loading: false
    };
  },
  watch: {
    // Observar cambios en el tipo de feriado seleccionado
    'form.nacional': function(newVal, oldVal) {
      if (newVal === 2 || newVal === 3) {
        this.obtenerDepartamentos();
      } else {
        // Limpiar departamentos si no es tipo 2 o 3
        this.departamentos = [];
        this.form.id_parametro = null;
      }
    }
  },
  async mounted() {
    this.$bus.$on("openDialogModificarFeriado", async (item) => {
      this.form = { ...item };
      
      // Convertir la fecha al formato YYYY-MM-DD
      this.form.fecha = this.form.fecha.split("/").reverse().join("-");
      
      // Mapear los valores de nacional
      if (this.form.nacional === 0) {
        this.form.nacional = 2; // Departamental
      } else if (this.form.nacional === 2) {
        this.form.nacional = 3; // Internacional
      }
      
      // Si es departamental o internacional, cargar los departamentos
      if (this.form.nacional === 2 || this.form.nacional === 3) {
        await this.obtenerDepartamentos();
      } else {
        this.form.id_parametro = null;
      }
      
      this.dialog = true;
    });
  },
  methods: {
    close() {
      this.form = {};
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialog");
      this.dialog = false;
    },
    
    onTipoFeriadoChange() {
      if (this.form.nacional === 2 || this.form.nacional === 3) {
        this.obtenerDepartamentos();
      } else {
        this.departamentos = [];
        this.form.id_parametro = null;
      }
    },
    
    async obtenerDepartamentos() {
      try {
        let queryType = "";
        
        if (this.form.nacional === 2) {
          queryType = "departamentos";
        } else if (this.form.nacional === 3) {
          queryType = "departamentos_ext";
        } else {
          this.departamentos = [];
          return;
        }

        let res = await this.$service.graphql({
          query: `
            query {
              params(tipo:"${queryType}") {
                rows {
                  id
                  valor
                }
              }
            }
          `
        });
        
        this.departamentos = res.params.rows;
        
        // Asegurar que el id_parametro sea string para coincidir con los valores del combo
        if (this.form.id_parametro) {
          this.form.id_parametro = this.form.id_parametro.toString();
        }
      } catch (error) {
        console.log(error);
        this.$alert("Error al cargar departamentos", "", "Error");
      }
    },

    async save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          let tipoNacional = this.form.nacional;
          let idParametro = null;
          
          // Mapear tipos correctamente para la base de datos
          if (this.form.nacional === 1) {
            tipoNacional = 1; // Nacional
            idParametro = null;
          } else if (this.form.nacional === 2) {
            tipoNacional = 0; // Departamental (valor en BD)
            idParametro = this.form.id_parametro;
          } else if (this.form.nacional === 3) {
            tipoNacional = 2; // Internacional (valor en BD)
            idParametro = this.form.id_parametro;
          }

          let user = this.$storage.get("user");
          let feriado = {
            fecha: this.form.fecha,
            descripcion: this.form.descripcion,
            nacional: tipoNacional,
            id_parametro: idParametro
          };
          
          let respuesta = await this.$service.graphql({
            query: `
              query {
                runQuery(consulta:"select general.fn_actualiza_feriado(${parseInt(this.form.id_feriado)},'${feriado.fecha}','${feriado.descripcion}',${feriado.id_parametro},${feriado.nacional},${parseInt(user.id)})") {
                  respuesta
                }
              }
            `
          });
          
          respuesta = respuesta.runQuery.respuesta[0].fn_actualiza_feriado.split("|");
          if (respuesta[0] == "1") {
            this.$alert(respuesta[1], "", "Aviso");
            this.close();
          } else {
            this.$alert(respuesta[1], "", "Aviso");
          }
        } catch (error) {
          console.log(error);
          this.$alert("Error al actualizar el feriado", "", "Error");
        }
        this.loading = false;
      }
    }
  }
};
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/admin/feriado/dialogs/ModificarFeriado.vue